// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"footer_socialLink__SU7v6","socials":"footer_socials__123to","icon":"footer_icon__31mmi","fa-superpowers":"footer_fa-superpowers__3VkWe"};